import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../api/axiosInstance';
import { toast } from 'sonner';

const t = (name, fn, showToast = true) =>
  createAsyncThunk(name, async (arg, { rejectWithValue }) => {
    try { return await fn(arg); }
    catch (err) {
       if (showToast) {
      toast.error(err.response?.data?.message || err.message || 'Request failed');
       }
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  });

// ── Generate QR for batch (triggers background job) ──
export const generateQR = t('qr/generate', async (dto) => {
  const { data } = await api.post('QR/generate', dto);
  toast.success(data.data?.message || 'QR generation queued');
  return data.data;
});

// ── Create print job ──
export const createPrintJob = t('qr/printJob', async (dto) => {
  const { data } = await api.post('QR/print-job', dto);
  toast.success('Print job queued');
  return data.data;
});

// ── Get print job status ──
export const fetchPrintJob = t('qr/fetchPrintJob', async (id) => {
  const { data } = await api.get(`QR/print-job/${id}`);
  return data.data;
});

// ── Export QR CSV ──
export const exportQRCsv = t('qr/export', async ({ batchId, format }) => {
  const response = await api.get(`QR/export/${batchId}?format=${format || 'CSV'}`, {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `batch-${batchId}-qrcodes.csv`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  toast.success('Export downloaded');
  return true;
});

// ── Batch progress ──
export const fetchQRProgress = t('qr/progress', async (batchId) => {
  const { data } = await api.get(`QR/progress/${batchId}`);
  return data.data;
}, false);

const qrSlice = createSlice({
  name: 'qr',
  initialState: { generationResult: null, printJob: null, progress: null, loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(generateQR.pending, (s) => { s.loading = true; s.error = null; })
      .addCase(generateQR.fulfilled, (s, a) => { s.loading = false; s.generationResult = a.payload; })
      .addCase(generateQR.rejected, (s, a) => { s.loading = false; s.error = a.payload; })
      .addCase(createPrintJob.fulfilled, (s, a) => { s.printJob = a.payload; })
      .addCase(fetchPrintJob.fulfilled, (s, a) => { s.printJob = a.payload; })
      .addCase(fetchQRProgress.fulfilled, (s, a) => { s.progress = a.payload; });
  },
});

export default qrSlice.reducer;